import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';
import { IApexChartDataSeries } from './sales-employ-business.interfaces';

const baseRoute = '/dashboard/user-sales-month';

@Injectable({
  providedIn: 'root'
})
export class SalesEmployBusinessChartService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }

  getRefactoredStatisticsForChart(data: any): IApexChartDataSeries {
    const refactoredStatistics = Object.entries(data).map(
      ([user, salesByDay]: [string, any[]], index) => {
        return {
          name: user,
          data: salesByDay
        };
      }
    );

    return refactoredStatistics;
  }
}
